import React from "react";
import * as ReactDOM from "react-dom";
import { Spin } from "antd";
import _ from "lodash";

import Message from "./MessageBubble";
import MessageFile from "./MessageFile";

import ListComments from "../../GraphQL/Query/ListComments";

class ListMessages extends React.Component {
  scrollAtBottom = true;
  isFirst = true;
  subscription;
  state = {
    loadingMore: false
  };

  componentDidMount() {
    this.subscription = this.props.subscribeToComments();
  }

  componentWillUpdate(nextProps) {
    if (!this.props.loading) {
      const {
        listComments: { items: comments = [] }
      } = this.props.data;
      const {
        listComments: { items: nextComments = [] }
      } = nextProps.data;

      this.historyChanged = nextComments.length !== comments.length;

      if (this.historyChanged) {
        const { messageList } = this;
        const scrollPos = messageList.scrollTop;
        const scrollBottom =
          messageList.scrollHeight - messageList.clientHeight;
        this.scrollAtBottom = scrollBottom <= 0 || scrollPos === scrollBottom;
        if (!this.scrollAtBottom) {
          const numMessages = messageList.childNodes.length;

          this.topMessage =
            numMessages === 0 ? null : messageList.childNodes[0];
        }
      }
    }
  }

  componentDidUpdate() {
    if (!this.props.loading) {
      if (this.isFirst) {
        this.scrollToBottom();
        this.isFirst = false;
      }

      if (this.historyChanged) {
        if (this.scrollAtBottom || this.props.isNewMessage) {
          this.scrollToBottom();
          this.props.setIsNewMessage();
        }
        if (this.topMessage && !this.props.isNewMessage) {
          this.topMessage.scrollIntoView();
        }
      }
    }
  }

  componentWillUnmount() {
    this.subscription();
  }

  onScroll = () => {
    const { data, orderId, fetchMore } = this.props;
    const {
      listComments: { nextToken }
    } = data;
    const scrollTop = this.messageList.scrollTop;
    if (scrollTop === 0 && nextToken) {
      this.onLoadMore(fetchMore, orderId, nextToken);
    }
  };

  scrollToBottom = () => {
    const { messageList } = this;
    const scrollHeight = messageList.scrollHeight;
    const height = messageList.clientHeight;
    const maxScrollTop = scrollHeight - height;
    ReactDOM.findDOMNode(messageList).scrollTop =
      maxScrollTop > 0 ? maxScrollTop : 0;
  };

  onLoadMore = (fetchMore, orderId, nextToken) => {
    this.setState({ loadingMore: true });
    fetchMore({
      query: ListComments,
      variables: { orderId, nextToken },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        const previousEntry = previousResult.listComments;
        const newComments = fetchMoreResult.listComments.items;
        const nextToken = fetchMoreResult.listComments.nextToken;

        return {
          listComments: {
            items: [...previousEntry.items, ...newComments],
            nextToken,
            __typename: "CommentConnection"
          }
        };
      }
    }).then(() => this.setState({ loadingMore: false }));
  };

  render() {
    const { loading, error, data, user } = this.props;
    if (loading && !data.listComments) {
      return <Spin />;
    }
    if (error) return <p>Error :(</p>;

    const {
      listComments: { items: comments = [] }
    } = data;

    return (
      <div
        ref={messageList => (this.messageList = messageList)}
        onScroll={this.onScroll}
        className="messenger-list__inner"
      >
        {comments && comments.length ? (
          _.map(comments.slice(0).reverse(), comment => {
            if (comment.files && comment.files.length) {
              return (
                <React.Fragment key={comment.id}>
                  {_.map(comment.files, (file, index) => {
                    return (
                      <Message
                        key={`${comment.id}-${index}`}
                        comment={comment}
                        user={user}
                      >
                        <MessageFile file={file} />
                      </Message>
                    );
                  })}
                  {!comment.message ? null : (
                    <Message comment={comment} user={user}>
                      <span className="message-text">{comment.message}</span>
                    </Message>
                  )}
                </React.Fragment>
              );
            }

            return (
              <Message key={comment.id} comment={comment} user={user}>
                <span className="message-text">{comment.message}</span>
              </Message>
            );
          })
        ) : (
          <div>No hay mensajes</div>
        )}
      </div>
    );
  }
}

export default ListMessages;



// WEBPACK FOOTER //
// ./src/Components/Comments/ListMessages.js